import { RegistrationStateCard } from "@/components/registration/RegistrationStateCard";

interface InvalidCollegeScreenProps {
  collegeCode?: string;
}

export function InvalidCollegeScreen({ collegeCode }: InvalidCollegeScreenProps) {
  const invalidCodeNote = collegeCode
    ? `The link code "${collegeCode}" does not match any active college registration link.`
    : "The college code in the URL does not match any active college registration link.";

  return (
    <RegistrationStateCard
      title="Invalid Registration Link"
      description="Please use the official registration link shared by your college or placement team."
      note={invalidCodeNote}
      icon="invalid"
      tone="danger"
    />
  );
}
